import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';
import moment from 'moment';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { FACTURA, BOLETA_DE_VENTA, OTROS } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';

import importacionService from '../../../service/logistica/importacionService';
import servicioImportacionService from '../../../service/logistica/servicioImportacionService';
import impotacionServicioService from '../../../service/administracion/impotacionServicioService';
import monedaService from '../../../service/administracion/monedaService';
import proyectoService from '../../../service/administracion/proyectoService';
import almacenService from '../../../service/administracion/almacenService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import productoService from '../../../service/administracion/productoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import BuscarProductoModal from './BuscarProductoModal';
import BuscarServicioModal from './BuscarServicioModal';
import ImprimirModal from './ImprimirModal';

var referenciaCount = 1;

export default class Index extends PaginationBase {
    constructor (props) {
        super(props);
        // this.props.onSetBreadcrumb();

        this.state = {
            loadingSource: true,
            monedas: [],
            proyectos: [],
            tiposCambioDiario: [],
            tiposComprobante: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            onSetFieldsValue: null,
            onGetFieldValue: null,
            filter: {
                documento: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            productoVisible: false,
            servicioVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productos: [],
            servicios: [],
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            servicioModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            importarOrdenCompraModal: {
                nombre: '',
                dataSource: []
            },
            imprimirFormValues: {
                file: undefined,
                idImportacion: 0
            }
        }

    }

    fetchEmptyFormValues = (objEdit) => {

        return {
            id: objEdit !== undefined ? objEdit.importacion.id : 0,
            documento : objEdit !== undefined ? objEdit.importacion.documento : '',
            idMoneda : objEdit !== undefined ? objEdit.importacion.idMoneda : SOLES,
            idProyecto : objEdit !== undefined ? objEdit.importacion.idProyecto : 0,
            idEstablecimiento: objEdit !== undefined ? objEdit.importacion.idEstablecimiento : 0,
            idAlmacen: objEdit !== undefined ? objEdit.importacion.idAlmacen : 0,
            documentoVale: objEdit !== undefined ? (objEdit.importacion.serieMovimiento + '-' + objEdit.importacion.numeroDocumentoMovimiento) : '',
            tipoCambio: objEdit !== undefined ? objEdit.importacion.tipoCambio : 0,
            observacion: objEdit !== undefined ? objEdit.importacion.observacion : '',
            activeKey: "1",
            idListaPrecio: 0,
            
            fechaStr: objEdit !== undefined ? objEdit.importacion.fechaStr : global.fetchCurrentDateStr(),
            fechaValeStr: objEdit !== undefined ? objEdit.importacion.fechaMovimientoStr : global.fetchCurrentDateStr(),
            monedas : [],
            proyectos : [],
            almacenes : [],
            listasPrecio: [],
            establecimientos: [],

            listaDetalleProductos: [],
            listaDetalleServicios: [],
            listaDetalleReferencias: [],

            arrListaDetalleProductos: [],
            arrListaDetalleServicios: [],

            isReadOnly: false
        }
    }

    handleChangeForm = async (property, value) => {
        if (property === "idEstablecimiento") {
            //debugger
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : []
                }
            });
        }
    }


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            serie: '',
            documento: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    }

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenModalBuscarProducto();

            if (this.state.formValues.activeKey === "2")
                this.handleOpenModalBuscarServicio();

            if (this.state.formValues.activeKey === "3")
                this.handleAddReferencia();
        });
    };

    handleOpenModalBuscarProducto = async () => {
        this.setState({
            productoVisible: true,
            productoModal: {
                ...this.state.productoModal,
                dataSource: this.state.productos
            }
        });
    }

    handleOpenModalBuscarServicio = async () => {
        this.setState({
            servicioVisible: true,
            servicioModal: {
                ...this.state.servicioModal,
                dataSource: this.state.servicios
            }
        });
    }

    handleSelectedRowProducto = (selected, rows) => {
        debugger
        var listaDetalleProductos = this.state.formValues.listaDetalleProductos;

        rows.forEach(item => {
            var filter = this.state.formValues.listaDetalleProductos.filter(m => { return m.idProducto === item.id; });
            if (filter.length === 0) {
                
                const fecha = moment(this.state.formValues.fechaStr, 'DD/MM/YYYY');
                const minFecha = fecha.format('YYYY/MM/DD');

                listaDetalleProductos.push({
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.id,
                    ordenCompra: '',
                    codigo: item.codigoReferencia,
                    nombre: item.nombre,
                    fechaVencimiento: this.state.formValues.fechaStr,
                    minFechaStr: minFecha,
                    lote: '',
                    cantidad: 0,
                    precioUnitarioOrigen: 0,
                    totalOrigen: 0,
                    precioUnitarioCosteo: 0,
                    totalCosteo: 0,

                    isReadOnly: false
                })
            }
        });

        listaDetalleProductos = listaDetalleProductos.filter(m => selected.filter(f => f === m.idProducto).length);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaDetalleProductos: listaDetalleProductos
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selected
            }
        });
    };

    handleSelectedRowServicio = (selected, rows) => {
        debugger
        var listaDetalleServicios = this.state.formValues.listaDetalleServicios;

        rows.forEach(item => {
            var filter = this.state.formValues.listaDetalleServicios.filter(m => { return m.id === item.id; });
            if (filter.length === 0) {
                
                listaDetalleServicios.push({
                    identifier: global.fetchUniqueCode(),
                    id: item.id,
                    nombre: item.nombre,
                    tipoCambio: this.state.formValues.tipoCambio,
                    soles: 0,
                    dolares: 0,
                    isReadOnly: false
                })
            }
        });

        listaDetalleServicios = listaDetalleServicios.filter(m => selected.filter(f => f === m.id).length);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaDetalleServicios: listaDetalleServicios
            },
            servicioModal: {
                ...this.state.servicioModal,
                selectedRowKeys: selected
            }
        });
    };

    handleAddReferencia = () => {
        var listaDetalleReferencias = this.state.formValues.listaDetalleReferencias;

        listaDetalleReferencias.push({
            identifier: referenciaCount,
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: true,
            isReadOnly: false
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaDetalleReferencias: listaDetalleReferencias
            }
        });
    };

    handleRemoverReferencia = (id) => {
        var listaDetalleReferencias = this.state.formValues.listaDetalleReferencias.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaDetalleReferencias: listaDetalleReferencias
            },
        });
    }

    handleNew = async () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.proyectos = this.state.proyectos;
        formValues.establecimientos = this.state.establecimientos;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        
        var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        var servicios = await impotacionServicioService.listar();

        this.setState({
            visible: true,
            formValues,
            productos: productos ? productos : [],
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: []
            },
            servicios: servicios ? servicios : [],
            servicioModal: {
                ...this.state.servicioModal,
                selectedRowKeys: []
            },
        });
    }

    handleVer = async (values, isEdit) => {
        //(values, false)
        this.handleEdit(values, false);
    }

    handleEdit = async (values, isEdit) => {
        debugger
        const dataEdit = await importacionService.obtenerPorId(values.id);

        var formValues = this.fetchEmptyFormValues(dataEdit);
        formValues.isReadOnly = !isEdit;
        formValues.monedas = this.state.monedas;
        formValues.proyectos = this.state.proyectos;
        formValues.establecimientos = this.state.establecimientos;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.activeKey ="3";
        var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        var servicios = await servicioImportacionService.listar();

        const almacenes = await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
        formValues.almacenes= almacenes;

        var arrSelectProducts = [];
        dataEdit.importacionProductoDetalles.forEach(item => {
            debugger
            const fecha = moment(item.fechaStr, 'DD/MM/YYYY');
            const minFecha = fecha.format('YYYY/MM/DD');
            const producto = {
                identifier: global.fetchUniqueCode(),
                idProducto: item.idProducto,
                ordenCompra: '',
                codigo: item.codigoReferencia,
                nombre: item.nombreProducto,
                fechaVencimiento: moment(item.fechaStr, 'DD/MM/YYYY').format('DD/MM/YYYY'), //item.fechaStr,
                minFechaStr: minFecha,
                lote: item.lote,
                cantidad: item.cantidad,
                precioUnitarioOrigen: item.precioUnitario,
                totalOrigen: item.total,
                precioUnitarioCosteo: item.precioUnitarioCosteo,
                totalCosteo: item.totalCosteo,  
                isReadOnly: !isEdit      
            };

            // if (isEdit === false) { producto.isReadOnly = !isEdit; }

            const itemArrProd = {
                identifier: producto.identifier,
                idProducto: producto.idProducto,
                fechaVencimiento: producto.fechaVencimiento,
                lote: producto.lote,
                nombre: producto.nombre,
                cantidad: producto.cantidad,
                calculoPrecioUnitOrigen: item.precioUnitario,
                calculoPrecioTotalOrigen: item.total,
                calculoPrecioUnitCosteo: item.precioUnitarioCosteo,
                calculoPrecioTotalCosteo: item.totalCosteo
            }

            formValues.arrListaDetalleProductos.push(itemArrProd);
            formValues.listaDetalleProductos.push(producto);
            arrSelectProducts.push(producto.idProducto);
        });

        if (dataEdit.importacionServicioDetalles !== null && dataEdit.importacionServicioDetalles !== undefined) {
            dataEdit.importacionServicioDetalles.forEach(item => {
                const servicio ={
                    identifier: global.fetchUniqueCode(),
                    id: item.id,
                    nombre: item.nombreServicio,
                    tipoCambio: item.tipoCambio,
                    soles: item.soles,
                    dolares: item.dolares,
                    isReadOnly: !isEdit
                }
    
                const itemArrServ = {
                    identifier: servicio.identifier,
                    id: item.id,
                    tipoCambio: item.tipoCambio,
                    calculoEnSoles: item.soles,
                    calculoEnDolares: item.dolares
                }
    
                formValues.arrListaDetalleServicios.push(itemArrServ);
                formValues.listaDetalleServicios.push(servicio);
            });            
        }

        if (dataEdit.importacionReferencias !== null && dataEdit.importacionReferencias !== undefined) {
            dataEdit.importacionReferencias.forEach(item => {
                const referencia = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    isReadOnly: !isEdit
                };
        
                referenciaCount = referenciaCount + 1;
    
                formValues.listaDetalleReferencias.push(referencia);
            });            
        }

        this.setState({
            visible: true,
            formValues,
            productos: productos ? productos : [],
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: arrSelectProducts
            },
            servicios: servicios ? servicios : [],
            servicioModal: {
                ...this.state.servicioModal,
                selectedRowKeys: []
            },
        });
    }
    
    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var response;
            if (values.id === 0 || values.id === undefined)
                response = await importacionService.registrar(values);
            else
                response = await importacionService.modificar(values);

            if (response.status === 200) {
                // var empty = this.fetchEmptyFormValues();
                // this.setState({ visible: false, formValues: empty });
                // form.setFieldsValue(empty);
                form.resetFields();
                this.setState({ visible: false });

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleAnular = async (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var response = await importacionService.eliminar(values);
            
            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleExportExcel = async () => {
        var response = await importacionService.excel(this.state.filter);
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Transferencias.xlsx");
    }

    handleImprimir = async (item) => {
        
        var file = undefined;
        var response = await importacionService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idGuiaRemision: item.id
            }
        });
    };


    async componentDidMount() {
        this._initPagination(this.state.filter, importacionService.paginacion);

        var params = auth.user().parametros;
        console.log(params);

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const tiposComprobante = await tipoComprobanteService.listar();
        const listasPrecio = await listaPrecioService.listar();
        const proyectos = await proyectoService.listar();
        const establecimientos = await establecimientoService.principales();

        this.setState({
            loadingSource: false,
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            monedas: monedas ? monedas : [],
            listasPrecio: listasPrecio ? listasPrecio : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            proyectos: proyectos ? proyectos : [],
            establecimientos: establecimientos ? establecimientos : [],
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Importación"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onVer={this.handleVer}
                    onEditar={this.handleEdit}
                    onAnular={this.handleAnular}
                    onChange={this._handleChangePagination}
                    onImprimir={this.handleImprimir}
                />
                 <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    
                    onAgregarDetalle={this.handleAgregarDetalle}
                    
                    // onRemoverProducto={this.handleRemoverProducto}
                    // onRemoverReferencia={this.handleRemoverReferencia}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    // onBlur={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    // onChangeNameProduct={this.handleChangeNameProduct}
                />
                <BuscarProductoModal
                    visible={this.state.productoVisible}
                    formValues={this.state.productoModal}
                    onChange={this.handleChangeProductoModal}
                    onChangeRow={this.handleSelectedRowProducto}
                    onCancel={() => this.setState({ productoVisible: false })}
                />
                <BuscarServicioModal
                    visible={this.state.servicioVisible}
                    formValues={this.state.servicioModal}
                    onChange={this.handleChangeServicioModal}
                    onChangeRow={this.handleSelectedRowServicio}
                    onCancel={() => this.setState({ servicioVisible: false })}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />

            </div>
        )
    }
}
